// extracted by mini-css-extract-plugin
module.exports = {"blockquoteContainer":"blockquoteContainer___326mG","bq":"bq___RvTtE","cite":"cite___1Q01e"};